import { Link } from '@reach/router'
import styled from 'styled-components'
import StyleGuide from '@taglivros/oef_componentes/build/components/styleGuide'
import List from '@taglivros/oef_componentes/build/components/list'
import blueArrow from '../../../assets/imagens/arrow-blue.svg'
import React, { Fragment, useEffect, useState } from 'react'
import { useBoletoBancario } from '../../../contexts/BoletoBancarioContext'

import { isEmptyObject } from '../../../utils/helpers/helpers'
import { useGlobal } from '../../../contexts/GlobalContext'
import { getLinks } from './constantsBoletoBancario'
import { TITULO_PAGINA } from '../PagamentoCartaoCredito/constantsPagamentoCartaoCredito'
import ConteudoWrapper from '../../../components/ConteudoWrapper/ConteudoWrapper'
import BreadcrumbGlobal from '../../../components/BreadcrumbGlobal/BreadcrumbGlobal'
import CardPagamentoResumo from '../components/CardPagamentoResumo/CardPagamentoResumo'
import { getAssinaturaDoAssociadoPorModalidade } from '../../../utils/helpers/helpersAssinatura'

const TituloPagina = styled.h1`
  margin: 0 auto 10px;

  @media (max-width: ${StyleGuide.mediaQuery.mobile}) {
    margin: 0 auto;
  }
`

const PagamentoBoletoBancario = () => {
  const [ links, setLinks ] = useState()
  const [ idAssinatura, setIdAssinatura ] = useState()
  const [ plano, setPlano ] = useState()
  const { getInfosPagamento, infosPagamento } = useBoletoBancario()
  const { dadosGlobaisAssociado, modalidadeURL } = useGlobal()

  useEffect( () => {
    if ( !isEmptyObject( infosPagamento ) && plano ) {
      const linksBoleto = getLinks( infosPagamento, plano )
      if ( linksBoleto.length ) {
        setLinks( linksBoleto )
      }
    }
  }, [ infosPagamento, plano ] )

  useEffect( () => {
    if ( dadosGlobaisAssociado ) {
      const assinaturaObtida = getAssinaturaDoAssociadoPorModalidade( dadosGlobaisAssociado.assinaturas, modalidadeURL )

      if ( assinaturaObtida ) {
        setIdAssinatura( assinaturaObtida.id )
        setPlano( assinaturaObtida.plano )
      }
    }
  }, [ dadosGlobaisAssociado ] )

  useEffect( () => {
    if ( idAssinatura ) {
      getInfosPagamento( idAssinatura, dadosGlobaisAssociado.assinaturas )
    }
  }, [ idAssinatura ] )

  return (
    <Fragment>
      <BreadcrumbGlobal
        exactPath="pagamento"
        nomeAlternativo="Pagamento"
        padding="20px 0"
      />
      <TituloPagina>
        { TITULO_PAGINA }
      </TituloPagina>
      { !isEmptyObject( infosPagamento ) && links ?
        <ConteudoWrapper>
          <CardPagamentoResumo
            acaoPlanoPendente={ infosPagamento.acaoDePlanoPendente }
            mesTagUltimoKitPago={ infosPagamento.mesTagUltimoPedidoPago.visualizador }
            metodoPagamento={ infosPagamento.metodoPagamento }
            parcelas={ infosPagamento.parcelas }
            tipoPlano={ infosPagamento.tipoPlano }
            valor={ infosPagamento.valorLiquido }
            vencimento={ infosPagamento.vencimentoBoleto }
          />
          <List
            className="listPlano"
            itemPadding={ StyleGuide.isMobile() ? '20px' : '20px 40px' }
            items={ links }
          >
            {
              links.map( ( link ) => (
                link &&
                  <li key={ link.route }>
                    { link.linkExterno ?
                      <a
                        download
                        href={ link.route }
                      >
                        <div>
                          <h3>
                            { link.title }
                          </h3>
                          <span>
                            { link.subtitle }
                          </span>
                        </div>
                        <img
                          alt="flecha"
                          src={ blueArrow }
                        />
                      </a> :
                      <Link to={ link.route }>
                        <div>
                          <h3>
                            { link.title }
                          </h3>
                          <span>
                            { link.subtitle }
                          </span>
                        </div>
                        <img
                          alt="flecha"
                          src={ blueArrow }
                        />
                      </Link>}
                  </li>
              ) )
            }
          </List>
        </ConteudoWrapper> : null}
    </Fragment>
  )
}

export default PagamentoBoletoBancario

